import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { AppState } from 'src/app/ngrx/states'
import { store } from 'src/app/ngrx/store/actions'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { DdcDividerComponent } from 'src/app/shared/divider/divider.component'
import { DdcExploredCardsComponent } from '../../shared/ddc/ddc-explored-cards/ddc-explored-cards.component'
import { DdcStoreCardComponent } from '../../shared/ddc/ddc-store-card/ddc-store-card.component'
import { DaydicTypesIconNames, Themes } from '../../shared/enums/enums'

interface StoreCard {
  icon: string
  title: string
  subtitle: string
  colorClass: string
  route?: string
  queryParams?: Record<string, string>
  lingoBadge?: boolean
}

@Component({
  selector: 'ddc-store',
  templateUrl: './ddc-store.component.html',
  styleUrls: ['./ddc-store.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [DdcStoreCardComponent, DdcExploredCardsComponent, DdcDividerComponent],
})
export class DdcStoreComponent implements OnInit, OnDestroy {
  private _themeSubscription?: Subscription
  _isDarkTheme = false

  exploreCards: StoreCard[] = [
    {
      icon: 'flight',
      title: 'Travel',
      subtitle: 'Explore the world with confidence',
      colorClass: 'travel',
      route: '/store/travel',
    },
    {
      icon: 'school',
      title: 'Academy',
      subtitle: 'Learn and grow your skills',
      colorClass: 'academy',
      route: '/store/academy',
    },
    {
      icon: 'favorite',
      title: 'Love',
      subtitle: 'Find your perfect match',
      colorClass: 'love',
      route: '/store/love',
    },
    {
      icon: 'directions_car',
      title: 'Driver License',
      subtitle: 'Get ready for the road',
      colorClass: 'driving',
      route: '/store/driving-license',
    },
  ]

  lingoCards: StoreCard[] = [
    {
      icon: DaydicTypesIconNames.DICTIONARY,
      title: 'Dictionary',
      subtitle: 'AI-curated word collections',
      colorClass: 'dictionary',
      route: '/lingo',
      queryParams: { mode: 'dictionary' },
      lingoBadge: true,
    },
    {
      icon: DaydicTypesIconNames.NOTE,
      title: 'Note',
      subtitle: 'Smart study notes',
      colorClass: 'note',
      route: '/lingo',
      queryParams: { mode: 'note' },
      lingoBadge: true,
    },
    {
      icon: DaydicTypesIconNames.QUIZ,
      title: 'Quiz',
      subtitle: 'Test your knowledge',
      colorClass: 'quiz',
      route: '/lingo',
      queryParams: { mode: 'quiz' },
      lingoBadge: true,
    },
    {
      icon: DaydicTypesIconNames.FIGURE,
      title: 'Figure',
      subtitle: 'Visual concept maps',
      colorClass: 'figure',
      route: '/lingo',
      queryParams: { mode: 'figure' },
      lingoBadge: true,
    },
  ]

  constructor(
    private logger: DdcLoggerService,
    private ngrxStore: Store<AppState>,
    private router: Router,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.ngrxStore.dispatch(store())
    this._themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === Themes.DARK
    })
  }

  ngOnDestroy(): void {
    this._themeSubscription?.unsubscribe()
  }

  get lingoBadgeSrc(): string {
    return 'assets/media/logos/lingo_logo_white.png'
  }

  onCardClick(card: StoreCard): void {
    if (card.route) {
      this.router.navigate([card.route], { queryParams: card.queryParams })
    }
  }
}
